import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import { navigate } from 'gatsby'
import Button from '@mui/material/Button'

export interface StatusbarProps {
  setOpen: any
  open: boolean
  message: string
  duration?: number

  linkTitle?: string
  linkTarget?: string
}

export default function Statusbar(props: StatusbarProps) {
  const handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string,
  ) => {
    if (event !== null) {
      event.preventDefault()
      event.stopPropagation()
    }

    props.setOpen(false)

    if (reason === 'clickaway') {
      return
    }
  }

  const handleClick = () => {
    if (typeof props.linkTarget !== 'undefined') {
      navigate(props.linkTarget)
    }
  }

  let duration = 2000

  if (typeof props.duration !== 'undefined') {
    duration = props.duration
  }

  let button = null

  if (typeof props.linkTitle !== 'undefined') {
    button = (
      <Button
        color="primary"
        data-test="AddToCart"
        onClick={handleClick}
        size="small"
      >
        {props.linkTitle}
      </Button>
    )
  }

  return (
    <Snackbar
      action={
        <React.Fragment>
          {button}
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={handleClose}
            size="small"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      }
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={duration}
      message={props.message}
      onClose={handleClose}
      open={props.open}
    />
  )
}
